export default __webpack_public_path__ + "static/media/photo2.32f68b52.jpg";